import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import toaster from 'utils/toaster';

export interface ISaveGeneralSettings {
  company_name: string;
  allow_automatic_gps_clock_in: boolean;
  face_recognition_clock_in: boolean;
  job_clock_in: boolean;
  task_clock_in: boolean;
  mileage_in_km: boolean;
  time_off_in_menu: boolean;
  split_time: boolean;
  geofence_clock_in: boolean;
  block_website_clock_in: boolean;
  manual_breaks: boolean;
  mileage_clock_out: boolean;
  new_user_password_reset: boolean;
  timezone: string;
  date_format: string;
  mileage_cost: number;
  company_currency: string;
  lunch_break_automatically: boolean;
  lunch_break_duration: number;
  clock_out_gps_off: boolean;
  clock_out_force_close_app: boolean;
  driving_speed: number;
  cali_break_policy: boolean;
  show_signature_sign_off: boolean;
  commuter_mileage: boolean;
  has_evv: boolean;
  allows_kiosk_app: boolean;
  custom_fields: boolean;
}

const saveGeneralSettings = (postData: ISaveGeneralSettings) => {
  return http().post(endpoints.companySettings.generalSettings, postData);
};

export function useSaveGeneralSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveGeneralSettings,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });
      if (data.message) {
        toaster.success({ description: data.message });
      }
    },
  });
}
